export default [
  {
    //  404页面
    path: "*",
    name: "pageNotFound",
    component: () => import("@/views/404/index.vue"),
    meta: { title: "404页面", order: 20 },
  },
];
